import React from 'react';
function Navigation({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.885 10.333H6.218a.833.833 0 00-.833.834v1.666c0 .46.373.834.833.834h11.667c.46 0 .833-.373.833-.834v-1.666a.833.833 0 00-.833-.834zM17.885 4.5H6.218a.833.833 0 00-.833.833V7c0 .46.373.833.833.833h11.667c.46 0 .833-.373.833-.833V5.333a.833.833 0 00-.833-.833zM17.884 16.167h-7.5a.833.833 0 00-.833.833v1.667c0 .46.373.833.833.833h7.5c.46 0 .833-.373.833-.833V17a.833.833 0 00-.833-.833z"
      />
      <path
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M7.05 17.833h2.084m-2.083-3.75V17v-2.917z"
      />
    </svg>
  );
}

export default Navigation;
